import { render } from "./ThankYou.vue?vue&type=template&id=c7ef1ce6&scoped=true"
const script = {}

import "./ThankYou.vue?vue&type=style&index=0&id=c7ef1ce6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7ef1ce6"]])

export default __exports__